import React, { useState, useEffect } from 'react'
import { MdCheckBox, MdCheckBoxOutlineBlank } from 'react-icons/md'
import { useTranslation } from 'react-i18next'
import { getUser } from '../../../../services/oneUser'
import CookieManager from '../../../lib/CookiesManager'

interface JobOfferProps {
  formData: { title: string; description: string }
  handleFieldChange: (field: string, value: any) => void
}

const getStorageKey = () => {
  const currentPath = window.location.pathname
  if (currentPath === '/dashboard/announce-work/') {
    return 'myJobOffer'
  } else if (currentPath === '/dashboard/announce-event/') {
    return 'myEvent'
  } else if (currentPath === '/dashboard/announce-establishment/') {
    return 'myEstablishment'
  }
  return 'myAnnounce'
}

const JobOfferForm: React.FC<JobOfferProps> = ({}) => {
  const { t } = useTranslation()

  const getLocalStorageData = () => {
    const storageKey = getStorageKey()
    const data = localStorage.getItem(storageKey)
    return data ? JSON.parse(data) : {}
  }

  const [status, setStatus] = useState<string[]>(() => {
    const localStorageData = getLocalStorageData()
    return localStorageData.status || []
  })

  useEffect(() => {
    const fetchUserEmail = async () => {
      const userId = CookieManager.getUserId()
      const token = CookieManager.getToken()

      if (userId && token) {
        try {
          const userData = await getUser(userId, token)
          const userEmail = userData.user.email

          const storageKey = getStorageKey()
          const localStorageData = getLocalStorageData()
          localStorageData.email = userEmail
          localStorage.setItem(storageKey, JSON.stringify(localStorageData))
        } catch (error) {
          console.error('Error fetching user email:', error)
        }
      }
    }

    fetchUserEmail()
  }, [])

  useEffect(() => {
    const userId = CookieManager.getUserId()
    const localStorageData = getLocalStorageData()

    if (userId) {
      localStorageData.userId = userId
    }

    if (!localStorageData.location) {
      localStorageData.location = []
    }
    if (!localStorageData.practices) {
      localStorageData.practices = []
    }

    localStorage.setItem(getStorageKey(), JSON.stringify(localStorageData))
  }, [])

  const options = [
    { id: 'maison privee', description: t('create-ad.brothel') },
    { id: 'bars et clubs prive', description: t('create-ad.private-club') },
    { id: 'salons de massage', description: t('create-ad.massage-parlor') },
    { id: 'hotels coquins', description: t('create-ad.naughty-hotel') },
    { id: 'saunas prives', description: t('create-ad.spa-and-wellness') },
    { id: 'clubs echangistes', description: t('create-ad.swinger-club') },
  ]

  useEffect(() => {
    const localStorageData = getLocalStorageData()
    localStorageData.status = status
    localStorage.setItem(getStorageKey(), JSON.stringify(localStorageData))
  }, [status])

  const handleSelectionChange = (option: string) => {
    setStatus(prevStatus =>
      prevStatus.includes(option)
        ? prevStatus.filter(item => item !== option)
        : [...prevStatus, option],
    )
  }

  return (
    <>
      <div className='flex gap-2 sm:gap-3 lg:gap-4 justify-between uppercase text-center font-bold'></div>
      <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 sm:gap-3 lg:gap-4'>
        {options.map(option => (
          <div
            key={option.id}
            className={`p-2 sm:p-3 lg:p-4 cursor-pointer text-center rounded-lg text-anthracite ${
              status.includes(option.id)
                ? 'bg-redpink text-white'
                : 'bg-grisclair'
            }`}
            onClick={() => handleSelectionChange(option.id)}
          >
            <div className='flex items-center justify-center bg-anthracite p-2 sm:p-3 uppercase rounded-md'>
              {status.includes(option.id) ? (
                <MdCheckBox className='mr-2 sm:mr-3 text-base sm:text-lg lg:text-xl' />
              ) : (
                <MdCheckBoxOutlineBlank className='mr-2 sm:mr-3 text-base sm:text-lg lg:text-xl text-white' />
              )}
              <div>
                <div className='block text-white text-sm sm:text-base'>
                  {t(`create-ad.${option.id}`)}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  )
}

export default JobOfferForm
